import primaryComponents from "../../primaryComponents";
import styles from "./CreateExpenseCategory.module.scss";
import Validation from "./Validation";
import useCreateExpenseCategory from "./useCreateExpenseCategory";

const CreateExpenseCategory = ({
  closeWidget,
  categoryDetails = null,
  isEditMode = false,
}) => {
  const {
    isUpdatingCategory,
    isCreatingCategory,
    categoryName,
    setCategoryName,
    handleAddExpenseCategory,
  } = useCreateExpenseCategory({
    closeWidget,
    categoryDetails,
    isEditMode,
  });
  const {
    handleSubmit,
    formState: { errors },
    control,
    trigger,
  } = Validation({ categoryName });

  return (
    <form
      className={styles.createExpenseCategory__form}
      id="expenseCategoryForm"
    >
      <primaryComponents.InputFieldV2
        name="categoryName"
        control={control}
        label="Category Name"
        isRequired
        placeholder="Enter your category name"
        type="text"
        className="white"
        errorMessage={errors.categoryName}
        value={categoryName}
        onKeyUp={() =>
          errors.categoryName !== undefined && trigger("categoryName")
        }
        onChange={({ target: { value } }) => {
          setCategoryName(value);
        }}
      />

      <primaryComponents.Button
        classNames="btn btn--primary cover"
        type="submit"
        form="expenseCategoryForm"
        isLoading={isCreatingCategory || isUpdatingCategory}
        isDisabled={isCreatingCategory || isUpdatingCategory}
        loadingText={!isEditMode ? "Creating..." : "Updating..."}
        onClick={handleSubmit(handleAddExpenseCategory)}
      >
        {!isEditMode ? "Create category" : "Update category"}
      </primaryComponents.Button>
    </form>
  );
};
export default CreateExpenseCategory;
